
// eslint-disable-next-line import/no-named-as-default
import Swiper, { Scrollbar, Pagination, Navigation, Autoplay } from 'swiper'
export default {
  props: {
    scrollBar: {
      type: Boolean,
      default: false,
    },
    controls: {
      type: Boolean,
      default: false,
    },
    isWishlist: {
      type: Boolean,
      default: false,
    },
    slidesPerView: {
      type: [Number, String],
      default: 'auto',
    },
    spaceBetween: {
      type: Number,
      default: null,
    },
    direction: {
      type: String,
      default: 'horizontal',
    },
    draggable: {
      type: Boolean,
      default: false,
    },
    autoplay: {
      type: [Boolean, Number],
      default: false,
    },
    pagination: {
      type: Boolean,
      default: false,
    },
    slideTransitions: {
      type: Boolean,
      default: true,
    },
    loop: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    slider: null,
    hovered: false,
  }),
  mounted() {
    this.slider = new Swiper(this.$refs.swiper, {
      modules: [Scrollbar, Pagination, Navigation, Autoplay],
      direction: this.direction,
      slidesPerView: this.slidesPerView,
      spaceBetween: this.spaceBetween,
      scrollbar: this.scrollBar
        ? {
            el: '.swiper-scrollbar',
            hide: true,
            draggable: true,
          }
        : false,
      speed: 500,
      allowTouchMove: this.draggable,
      preventClicks: true,
      preventClicksPropagation: true,
      watchSlidesVisibility: true,
      loop: this.loop,
      autoplay: {
        delay: this.autoplay,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
        enabled: this.autoplay,
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        dynamicBullets: false,
        clickable: true,
      },
    })
  },
  methods: {
    next() {
      this.slider.slideNext()
    },
    prev() {
      this.slider.slidePrev()
    },
  },
}
